// TokioCoverageManager.tsx

import { Box, Paper, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import * as React from "react";
import { CoverageGroup } from "../../../../../shared/services/api/fire/types";
import { CoverageAccordion } from "../components/CoverageAccordion";

type PropertyType = "residential" | "commercial";

interface TokioCoverageManagerProps {
	isLoading: boolean;
	coverageTipo: PropertyType;
	setCoverageTipoAndDirty: (value: PropertyType) => void;
	filteredCoverages: CoverageGroup[];
	expandedCoverage: string | false;
	handleCoverageChange: (panelKey: string) => (event: React.SyntheticEvent, newExpanded: boolean) => void;
	onSuccessfulUpdate: () => void;
}

export const TokioCoverageManager: React.FC<TokioCoverageManagerProps> = React.memo(
	({ isLoading, coverageTipo, setCoverageTipoAndDirty, filteredCoverages, expandedCoverage, handleCoverageChange }) => {
		return (
			<>
				<Box margin={1} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0} mt={2}>
					<Box px={2} pt={1} pb={0.5} display="flex" alignItems="center" gap={2} mb={2}>
						<Typography variant="h6" color="primary">
							Coberturas
						</Typography>

						<ToggleButtonGroup
							size="small"
							exclusive
							value={coverageTipo}
							onChange={(_, v) => v && setCoverageTipoAndDirty(v as PropertyType)}
							disabled={isLoading}
						>
							<ToggleButton value="residential">Residencial</ToggleButton>
							<ToggleButton value="commercial">Comercial</ToggleButton>
						</ToggleButtonGroup>
					</Box>
				</Box>

				{/* Container dos Acordeões */}
				<Box px={1}>
					{filteredCoverages.map((group) => (
						<CoverageAccordion
							key={group.groupKey}
							group={group}
							disabled={isLoading}
							expanded={expandedCoverage === group.groupKey}
							onChange={handleCoverageChange(group.groupKey)}
						/>
					))}
				</Box>

				{/* Mensagem de Cobertura Vazia */}
				{filteredCoverages.length === 0 && !isLoading && (
					<Box px={2} mb={2}>
						<Typography variant="body2" color="textSecondary">
							Nenhuma cobertura encontrada para a categoria **{coverageTipo === "residential" ? "Residencial" : "Comercial"}**.
						</Typography>
					</Box>
				)}
			</>
		);
	}
);
